import React from 'react';
import '../styles/global.css';
import '../styles/Instructions.css'

function Instructions() {
    return (
        <div className='instruct-pg'>
            <div className="i-main-section">
                <h1 className="i-heading">Instructions</h1>
                <div className="i-desc">
                    <b>Please bring:</b>
                    <ol>
                        <li>A currently valid government-issued photo ID—a passport, country or state ID, or US Driver License.</li>
                        <li>Your insurance card.</li>
                        <li>Vaccination records, including the COVID-19 vaccine.</li>
                        <li>Payment with cash, personal check or credit card. 
                            Payment is different depending on what needs to be done according to your age or immunization history; please call to inquire.</li>
                    </ol>
                    <br></br>
                    <b>What to Expect:</b>
                    <ol>
                        <li>We provide I-693 form and assist you in filling out the form.</li>
                        <li>An interview by the physician.</li>
                        <li>Blood +/- urine tests according to your age; you can eat and drink before the exam.</li>
                        <li>Vaccines can be given if needed.</li>
                        <li>If other exams are needed, we will make arrangements for you.</li>
                    </ol>
                    Most people will pass the exam as long as you do not have active, contagious disease(s), substance abuse 
                    or uncontrolled mental illness.
                </div>
            </div>
        </div>
    );
}

export default Instructions;